__turbopack_context__.v({
  "close": "index-module-scss-module__nMYamG__close",
  "content": "index-module-scss-module__nMYamG__content",
  "count": "index-module-scss-module__nMYamG__count",
  "count-info": "index-module-scss-module__nMYamG__count-info",
  "discount": "index-module-scss-module__nMYamG__discount",
  "discount-info": "index-module-scss-module__nMYamG__discount-info",
  "layout": "index-module-scss-module__nMYamG__layout",
  "name": "index-module-scss-module__nMYamG__name",
  "name-info": "index-module-scss-module__nMYamG__name-info",
  "payment": "index-module-scss-module__nMYamG__payment",
  "payment-info": "index-module-scss-module__nMYamG__payment-info",
  "refuelingList": "index-module-scss-module__nMYamG__refuelingList",
  "refuelingRequest": "index-module-scss-module__nMYamG__refuelingRequest",
  "remind": "index-module-scss-module__nMYamG__remind",
  "subText": "index-module-scss-module__nMYamG__subText",
  "title": "index-module-scss-module__nMYamG__title",
  "total": "index-module-scss-module__nMYamG__total",
  "total-info": "index-module-scss-module__nMYamG__total-info",
});
